import { SubscriptionHandler } from "./SubscriptionHandlerV2";
export const subscriptionHandlerInstance = new SubscriptionHandler();
